import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { InstagramMediaI } from '@interfaces/instagram/instagram-media.interface';

@Injectable({
  providedIn: 'root',
})
export class InstagramService {
  private baseURL = environment.OMNISMART_API_INSTAGRAM_DIRECT;
  private slugURL = 'webhook-direct-provider';

  constructor(private readonly httpService: HttpClient) {}

  public checkMedia(url: string): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('url', url);

    return this.httpService.get(`${this.baseURL}${this.slugURL}/check-media`, { params: httpParams });
  }

  public getMedias(id: string): Observable<InstagramMediaI[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('id', id);

    return this.httpService.get<InstagramMediaI[]>(`${this.baseURL}${this.slugURL}/user-medias`, {
      params: httpParams,
    });
  }
}
